import { render, staticRenderFns } from "./ColorFabric.vue?vue&type=template&id=88f9cd84&scoped=true&"
import script from "./ColorFabric.vue?vue&type=script&lang=js&"
export * from "./ColorFabric.vue?vue&type=script&lang=js&"
import style0 from "./ColorFabric.vue?vue&type=style&index=0&id=88f9cd84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f9cd84",
  null
  
)

export default component.exports